import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Money from 'components/formatters/money-formatter';
import AddTransactionButton from 'modules/budget/components/budget-buttons/add-transaction-button';
import ColorMoney from 'components/formatters/color-money-formatter';
import CollapseIndicator from 'components/indicators/collapse-indicator';
import { inject, observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import TransactionSubtable from 'modules/budget/components/budget-table/transaction-subtable';
import SmallCategoryButtons from 'modules/budget/components/budget-table/small-category-buttons';

@withNamespaces()
@inject('store')
@observer
class SmallCategory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(state => ({open: !state.open}));
    }

    render() {
        const { open } = this.state;
        const { t, category } = this.props;
        const { isMobile } = this.props.store.app;
        const { name, budgeted, actual, remaining, transactions } = category;
        const isUnbudgeted = budgeted === 0;

        return (
            <Fragment>
                <tr className={`${open ? 'row-details-open' : ''}`}>
                    <td onClick={this.toggle} className="category-name-block" colSpan={isMobile ? 3 : 1}>
                        <CollapseIndicator open={open} />
                        <span className={isMobile && isUnbudgeted ? 'badge badge-danger mx-2' : ''}>
                            { t(name) }
                        </span>
                        {isUnbudgeted && (
                            <span className="badge badge-danger mx-2 hidden-sm hidden-xs">{t('BUDGET.TABLE.UNBUDGETED')}</span>
                        )}
                    </td>
                    <td className="hidden-sm hidden-xs text-right">
                        <Money value={budgeted} />
                    </td>
                    <td className="hidden-sm hidden-xs text-right">
                        <Money value={actual} />
                        &nbsp;
                        <AddTransactionButton category={category}>
                            <button className="btn btn-default btn-budget-add">
                                <FontAwesomeIcon className="plus-icon" icon={faPlus} />
                            </button>
                        </AddTransactionButton>
                    </td>
                    <td colSpan={isMobile ? 2 : 1} className="text-right">
                        <ColorMoney value={remaining} />
                    </td>
                    <td>
                        <SmallCategoryButtons category={category} />
                    </td>
                </tr>
                {open && <TransactionSubtable transactions={transactions} category={category} />}
            </Fragment>
        )
    }
}

SmallCategory.propTypes = {
    /** SmallCategory instance */
    category: PropTypes.any.isRequired,
};

export default SmallCategory;



// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-table/small-category.js